<ngx-slick-carousel #slickModal="slick-carousel" class="carousel" (init)="slickInit($event)" [config]="slickConfig" (beforeChange)="beforeChange($event)">
  @for (field of component.fields; track field) {
    <div ngxSlickItem class="slide" style="position:relative">
      <div class="desktop desktop-image-carousel-container" style="background-image:url({{field.desktop_image.url}});">
        @if (field.desktop_text) {
          <div class="desktop-image-carousel" [innerHTML]="field.desktop_text[0].text | safeHtml"></div>
        }
      </div>
      <div class="mobile mobile-image-carousel-container" style="background-image:url({{field.mobile_image.url}});">
        @if (field.mobile_text) {
          <div class="mobile-image-carousel" [innerHTML]="field.mobile_text[0].text | safeHtml"></div>
        }
      </div>
    </div>
  }
</ngx-slick-carousel>

